import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Line } from "@ant-design/plots";

const RollingSuccessRateChart = (props) => {
  const { rollingSuccessRate, rollingWindow } =
    props.optionsResults.metrics;

  if (!rollingSuccessRate.length) {
    return (
      <GenericCard
        title="Rolling success rate"
        isCardOpenByDefault={false}
        className="table-card"
      >
        <p>Not enough signals yet for a {rollingWindow}-signal rolling window.</p>
      </GenericCard>
    );
  }

  const config = {
    data: rollingSuccessRate,
    xField: "date",
    yField: "successRate",
    xAxis: { type: "timeCat", tickCount: 5 },
  };

  return (
    <GenericCard
      title={`Rolling success rate (trailing ${rollingWindow} signals)`}
      tooltipText="Trailing-window success rate over time -- a more granular view of drift than a single first-half/second-half split. A steadily declining line means the signal's edge may be eroding, not just noisy."
      maxHeight={500}
      isCardOpenByDefault={false}
      className="table-card"
    >
      <Line {...config} height={350} autoFit={false} />
    </GenericCard>
  );
};

RollingSuccessRateChart.propTypes = { optionsResults: PropTypes.object };

export default RollingSuccessRateChart;
